export const uniqueID = (radix = 36) =>
	Math.floor(Date.now() * Math.random()).toString(radix);
